import type { MaybeRef } from '@vueuse/shared'
export class Id {
  static get props() {
    return {
      id: String
    }
  }
  static use(idProp: MaybeRef<string | null | undefined>) {
    const getId = computed(() => {
      const thisId = unref(idProp) || `__UID__${Math.random().toString().slice(2, 8)}`
      return (suffix?: string) => (suffix ? `${thisId}__${suffix}` : thisId)
    })

    return { getId }
  }
}
